export const mandatoryPhone = {
  'Hello, friend!': 'Olá!',
  'We could not find your cellphone number through your social login':
    'Infelizmente não conseguimos encontrar seu número de celular através do seu login social',
  'Please fill in the field below to continue browsing':
    'Por favor, informe no campo abaixo para continuar navegando',
  PHONE_PLACEHOLDER: '(XX) XXXXX-XXXX',
};
